export function tratarStatus(contratos) {
    for (let i in contratos) {
        const condicaoPre = contratos[i].Grupo != null && contratos[i].Grupo.trim() === 'PRE';
        const condicaoRecusado = contratos[i].Aceite !== 'S' &&
            condicaoPre &&
            contratos[i].SignatureOrderLink !== null &&
            contratos[i].SignatureOrderLink.StatusLink === 3;

        if (condicaoPre && contratos[i].Status === 1)
            contratos[i].Status = 'PRE';

        if (!condicaoPre && contratos[i].Status === 1)
            contratos[i].Status = 'Ativo';

        if (contratos[i].Status === 2)
            contratos[i].Status = 'Suspenso';

        if (contratos[i].Status === 3)
            contratos[i].Status = 'Cancelado';

        if (condicaoRecusado)
            contratos[i].Status = 'Recusado';
    }
}
